
const state = {
    cardHolders: []
};

const getters = {
    cardHolders: (state) => state.cardHolders,
    noOfCardHolders: (state) => {
        //Business card with the status of active or pending
        let total = 0;
        for(var i = 0; i < state.cardHolders.length; i++) {
            if (state.cardHolders[i].status == 'Pending' || state.cardHolders[i].status == 'Active')
                total = total + 1; 
        }
        return total;
    },
    noOfActiveCardHolders: (state) => {
        //Business card with a status of active 
        let total = 0;
        for(var i = 0; i < state.cardHolders.length; i++) {
            if (state.cardHolders[i].status == 'Active')
                total = total + 1; 
        }
        return total;
    },

    noOfDeactiveCardHolders: (state) => {
        //Business card with a status of active 
        let total = 0;
        for(var i = 0; i < state.cardHolders.length; i++) {
            if (state.cardHolders[i].status == 'Deactivated')
                total = total + 1; 
        }
        return total;
    },

    noOfConnections: (state) => {
        let total = 0;
        for(var i = 0; i < state.cardHolders.length; i++) {
            total = total + (state.cardHolders[i].noOfConnections || 0); 
        }
        return total;
    },

    noOfIosUsers: (state) => {
        let total = 0;
        for(var i = 0; i < state.cardHolders.length; i++) {
            let platform = state.cardHolders[i].platform || '';
            if (platform == "ios" && state.cardHolders[i].status == 'Active')
                total = total + 1; 
        }
        return total;
    },

    noOfAndroidUsers: (state) => {
        let total = 0;
        for(var i = 0; i < state.cardHolders.length; i++) {
            let platform = state.cardHolders[i].platform || '';
            if (platform == "android" && state.cardHolders[i].status == 'Active')
                total = total + 1; 
        }
        return total;
    },
    
    noOfCardHoldersCreatedInBusinessPortal: (state) => {
        let total = 0, isCreatedInBusinessPortal;
        for(let i = 0 ;i < state.cardHolders.length; i++){        
            isCreatedInBusinessPortal =  state.cardHolders[i].isCreatedInApp == true ? false: true;
            if(isCreatedInBusinessPortal) total += 1;
        }

       return total;
    }
};

const actions = {
    async onCardHoldersSnapshot({ commit }, changes) {
            commit('setCardHolders', changes);
    },
    async clearCardholders({ commit }) {
        commit('clearCardholders');
    }
};

const mutations = {
    clearCardholders: (state) => {
        state.cardHolders = [];
    },
    setCardHolders: (state, changes) => {
        changes.forEach((change)=>{
            if (change.type === 'added') {
                state.cardHolders.push({
                  ...change.doc.data(),
                  name: change.doc.data().firstName +" "+change.doc.data().lastName,
                  businessCardId: change.doc.id,
                  cardIssue: mutations.formatDate(change.doc.data()?.creationDate?.toDate() || new Date()) || ''
              });
            }
            else if (change.type == 'modified') {
              //Replace the old cardholder object within the cardholder array with the modified object
              state.cardHolders.forEach((item, i)=> { 
                  if (item.businessCardId == change.doc.id)  {
                  //Remove the old object of the modified cardholder
                  state.cardHolders.splice(i,1)
                  //Add the modified cardholder
                  state.cardHolders.push({
                      ...change.doc.data(),
                      name: change.doc.data().firstName +" "+change.doc.data().lastName,
                      businessCardId: change.doc.id,
                      cardIssue: mutations.formatDate(change.doc.data()?.creationDate?.toDate() || new Date()) || ''
                  }); 
                  }
              });
            }
            else if (change.type == 'removed') {
                //Remove the cardholder object from the cardholder array
                state.cardHolders.forEach((item, i)=> { 
                    if (item.businessCardId == change.doc.id)  {
                        //Remove the object of the removed cardholder
                        state.cardHolders.splice(i,1)
                    }
                });
              }
        });
    },
    formatDate(date) {
        var dd = String(date.getDate()).padStart(2, '0');
        var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = date.getFullYear();
        return dd + '/' + mm + '/' + yyyy;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}